import { render, staticRenderFns } from "./Advertisement.vue?vue&type=template&id=d507a728&scoped=true&"
import script from "./Advertisement.js?vue&type=script&lang=js&"
export * from "./Advertisement.js?vue&type=script&lang=js&"
import style0 from "./Advertisement.css?vue&type=style&index=0&id=d507a728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d507a728",
  null
  
)

export default component.exports